<template>
  <div
    ref="singleCard"
    class="cards"
    :style="offSet"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right')
    }"
  >
    <h3>Other Projects</h3>

    <div class="inner">
      <slot></slot>
    </div>

    <div class="card-nav">
      <div class="prev" @click="counter--">Previous</div>
      <div class="next" @click="counter++">Next</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cards",
  data() {
    return {
      counter: 0,
      columns: 2
    };
  },

  methods: {
    swipe(direction) {
      direction === "Left" ? this.counter++ : this.counter--;
    }
  },

  computed: {
    state() {
      // one card slot card is always invisible on the actual page (wordpress card on wordpress page)
      return Math.abs(
        this.counter % (this.$slots.default.length - this.columns)
      );
    },
    offSet() {
      return {
        "--leftOffset": this.state * -100 + "%"
      };
    }
  },
  watch: {
    state() {
      this.columns = this.$el.clientWidth <= 516 ? 1 : 2;
    }
  }
};
</script>

<style lang="scss">
@import "../scss/_mixins.scss";

.cards .inner {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}
.card {
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 95%;
  transform: translateX(var(--leftOffset));
  transition: transform 0.25s ease-out;
  @include breakpoint(md) {
    min-width: 350px;
    flex-basis: 50%;
  }
}

.card-nav {
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  .prev,
  .next {
    min-width: 7rem;
    padding: 0.5rem 0;
    text-align: center;
    cursor: pointer;

    .dark & {
      filter: brightness(1);
      background-image: linear-gradient(
        45deg,
        rgba(117, 83, 142, 0.2),
        rgba(97, 1, 193, 0.2)
      );
      transition: filter 0.25s ease-in-out;
      color: #fff;
      @include ripple(0.8, 0.25s, white);
      &:hover {
        filter: brightness(1.4);
      }
    }
    .light & {
      filter: brightness(1);
      background-image: linear-gradient(45deg, #f7f7f7, #fbf5ff);
      transition: filter 0.25s ease-in-out;
      color: #311971;
      @include ripple(0.7, 0.25s, rebeccapurple);
      &:hover {
        filter: brightness(0.97);
      }
    }
  }
}
</style>
